"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import { useLocalizedStringFormatter } from 'react-aria';
import locales from '../../../../../../_virtual/_.locale.json@95341064edeb0e38b66d786dbd62955c.mjs';
import { Button } from '../../../Button/Button.mjs';
import { Action } from '../../../Action/Action.mjs';

const PasswordGenerateButton = (props) => {
  const { className, isDisabled, onGeneratePasswordAction } = props;
  const translate = useLocalizedStringFormatter(locales);
  return /* @__PURE__ */ jsx(Action, { action: onGeneratePasswordAction, children: /* @__PURE__ */ jsx(
    Button,
    {
      "data-component": "generatePassword",
      isDisabled,
      className,
      variant: "plain",
      color: "dark",
      children: translate.format("button.generate")
    }
  ) });
};

export { PasswordGenerateButton };
//# sourceMappingURL=PasswordGenerateButton.mjs.map
